{
  "search-join-attendee-submit-btn": "完成",
  "go-to-package-btn": "購買選項",
  "done-exit-btn": "完成（離開自助機）",
  "title-select-package": "選擇套裝",
  "title-suggest-a-product": "您想為訂單加購其他商品嗎？",
  "title-choose-a-product": "選擇要加入訂單的商品",
  "store-title": "請選擇您想購買的商品",
  "title-shopping-cart": "購物車",
  "select-images-notice-message": "請選擇您要列印的圖片。",
  "select-images-notice-ok": "確認",
  "confirm-change-img-btn": "確認，使用此圖片",
  "select-image-title": "OCCO 個人照片",
  "welcome-title": "相簿",
  "welcome-event-list-label": "活動清單:",
  "welcome-item-count-label": "項目數量:",
  "select-image-selection-title": "選擇（{{count}}）張圖片",
  "select-image-step-label": "步驟 {{currentStep}} / {{totalSteps}}",
  "select-image-for-product-text": "用於「{{title}}」",
  "select-image-next-btn": "下一步（{{selectedCount}}/{{requiredCount}}）",
  "select-image-clear-btn": "清除",
  "select-image-no-photos-message": "沒有可用照片",
  "select-image-no-uid-message": "糟糕，找不到您的帳戶。請再試一次。",
  "select-image-unlock-notice-message": "請選擇您要解鎖的圖片。",
  "select-image-print-or-unlock-notice-message": "請選擇您要列印或解鎖的圖片。",
  "select-image-addon-selection-title": "選擇圖片",
  "select-image-addon-done-count-btn": "完成（{{count}}）",
  "select-image-no-compatible-image-message": "找不到相容的圖片",
  "select-image-photo-limit-message": "請選擇 {{count}} 張要列印的圖片。",
  "welcome-gallery-title": "我的相簿",
  "welcome-select-images-of-yourself-title": "選擇所有您的照片",
  "welcome-select-found-images-title": "選擇要加入相簿的照片",
  "welcome-back-to-gallery-btn": "返回相簿",
  "checkout-subtotal-label": "小計:",
  "checkout-taxes-label": "稅金:",
  "checkout-total-label": "總計:",
  "checkout-btn": "結帳",
  "checkout-add-on-btn": "+ 加購",
  "checkout-add-product-btn": "新增商品",
  "checkout-empty-cart-message": "購物車是空的",
  "checkout-promo-code-placeholder": "僅供員工使用",
  "checkout-invalid-promo-code-message": "無效或已過期的優惠碼！",
  "checkout-discount-label": "折扣: {{title}}",
  "checkout-receipt-title": "收據",
  "checkout-receipt-product-label": "商品",
  "checkout-receipt-unit-price-label": "單價",
  "checkout-receipt-qty-label": "數量",
  "checkout-receipt-amount-label": "金額",
  "checkout-digital-package-upsell-message": "要將<br>數位套裝加入<br>購物車，並取得<br>所有數位內容的存取權嗎？",
  "photo-plus-pass-required-message": "您似乎尚未擁有 Photo+ Pass。<br><br>立即購買即可存取高解析度內容。",
  "photo-plus-valid-ticket-required-message": "您目前似乎尚未有本次園區行程的有效門票。請先連結門票，以享受 Photo+ 體驗。",
  "photo-plus-visit-availability-message": "您的 Photo+ 體驗僅在造訪 Genting SkyWorlds 期間可用。",
  "checkout-other-products-upsell-message": "要為您的數位套裝加購沖印嗎？",
  "checkout-delete-restriction-message": "若要購買加購項目，購物車中必須至少保留一個套裝。若要更換套裝，請先移除所有加購項目。",
  "checkout-digital-package-duplicate-message": "您的購物車中已有數位存取套裝。<br>在移除或購買目前套裝之前，無法新增新套裝。",
  "welcome-print-modal-title": "列印",
  "welcome-print-modal-text": "您的照片將會列印並交付給活動主辦方。",
  "cancel-btn": "取消",
  "welcome-preview-modal-title": "預覽",
  "close-btn": "關閉",
  "ok-btn": "確認",
  "back-btn": "返回",
  "info-title": "資訊",
  "apply-btn": "套用",
  "clear-btn": "清除",
  "yes-btn": "是",
  "no-btn": "否",
  "change-image-btn": "更換圖片",
  "done-btn": "完成",
  "skip-btn": "略過",
  "refresh-btn": "重新整理",
  "exit-btn": "離開",
  "unsupported-picture-format-message": "無效或不支援的圖片格式",
  "welcome-alert-modal-title": "對話框標題",
  "welcome-alert-modal-body-text": "對話框內容顯示於此。",
  "welcome-alert-save-btn": "儲存變更",
  "welcome-passcodes-modal-title": "產生通行碼",
  "welcome-passcodes-events-label": "請選擇要產生通行碼的活動：",
  "welcome-passcodes-email-label": "接收 XLS 格式通行碼的電子郵件地址：",
  "welcome-passcodes-count-label": "要產生的通行碼數量：",
  "welcome-passcodes-count-help": "介於 1-200,000 的數字",
  "welcome-passcodes-prepaid-label": "這些卡片持有人是否視為預付 / VIP？：",
  "welcome-passcodes-expiry-label": "公開自助機存取到期時間（分鐘）（輸入 0 以停用）：",
  "welcome-passcodes-url-prefix-label": "相簿存取 URL 前綴（例如 https://domain-name.com）：",
  "welcome-passcodes-generate-btn": "產生",
  "sharing-modal-title": "分享圖片",
  "sharing-tab-email": "Email",
  "sharing-tab-sms": "SMS",
  "sharing-email-name-placeholder": "全名",
  "sharing-email-placeholder": "有效電子郵件地址",
  "sharing-email-help-text": "多個電子郵件地址可用分號、逗號、空格或 Enter 鍵分隔。",
  "sharing-contact-phone-placeholder": "電話號碼",
  "sharing-company-placeholder": "公司 / 機構",
  "sharing-sms-name-placeholder": "全名",
  "sharing-sms-phone-placeholder": "有效電話號碼",
  "sharing-privacy-link": "隱私政策",
  "sharing-privacy-prefix": "我們非常重視您的隱私，請閱讀我們的",
  "welcome-delete-modal-title": "刪除",
  "welcome-delete-modal-body": "確定要從相簿刪除此圖片嗎？",
  "welcome-delete-photo-confirmation-message": "您確定要從相簿刪除此圖片嗎？",
  "welcome-delete-photo-keep-btn": "保留這張圖片！",
  "welcome-delete-photo-delete-btn": "從我的相簿刪除此圖片",
  "welcome-delete-reason-not-mine-btn": "是。這不是我的圖片",
  "welcome-delete-confirm-btn": "刪除",
  "welcome-selfie-modal-title": "以人臉搜尋我的圖片",
  "welcome-selfie-match-found-title": "我們可能找到您了！",
  "welcome-selfie-match-found-confirm-message": "點擊您的圖片以確認。",
  "welcome-selfie-capture-btn": "點此",
  "welcome-delete-reason-dont-want-btn": "是。這是我的圖片，但我不想要",
  "welcome-print-copy-count-label": "選擇列印份數",
  "catalog-select-product-package-title": "選擇商品套裝",
  "freedompay-offline-request-title": "請輸入離線交易請求 ID",
  "square-reader-access-token-title": "請輸入 Square Access Token",
  "square-reader-pairing-code-title": "請使用此代碼登入新的 Square reader，完成後按確認。",
  "square-reader-still-unpaired-text": "此裝置尚未配對，請使用代碼登入新的 Square reader。",
  "square-reader-security-note-title": "基於安全原因，以下兩組金鑰不會被儲存，請先記錄",
  "storicard-invalid-code-text": "無效的 StoriCard 代碼。",
  "header-menu-user-id-link": "UserID:",
  "countdown-time-up-text": "時間到！",
  "welcome-find-more-images-btn": "尋找更多圖片",
  "welcome-select-images-btn": "選擇圖片",
  "welcome-selected-images-next-btn": "這 {{count}} 張圖片中的是我，下一步 >",
  "welcome-invalid-attendee-id-message": "無效的 attendee ID。",
  "welcome-kiosk-time-expired-message": "抱歉，公開自助機使用時間已到",
  "welcome-grouping-error-message": "不允許合併 3 天前建立的帳戶。",
  "confirm-btn": "確認",
  "approved-btn": "已核准",
  "checkout-confirm-purchase-title": "請確認您的購買",
  "checkout-confirm-purchase-short-title": "確認購買",
  "checkout-digital-access-summary": "存取您今天拍攝的所有數位圖片",
  "checkout-and-text": "及",
  "checkout-print-count-summary": "{{count}} 份列印",
  "checkout-digitals-copy-message": "您要備份一份數位內容嗎？<br>以防卡片遺失。",
  "checkout-email-placeholder": "您的電子郵件",
  "checkout-email-or-phone-placeholder": "您的電子郵件或美國電話號碼",
  "checkout-sms-agreement-label": "我同意接收來自 Storibox 的通知訊息至上方提供的電話號碼。我明白我將收到包含更新與圖片連結的 SMS 訊息。可能會產生數據及訊息費用。如要取消，請回覆 STOP。",
  "checkout-name-placeholder": "您的姓名",
  "checkout-cancel-transaction-btn": "取消交易",
  "checkout-employee-authorization-title": "需要員工授權",
  "checkout-scan-employee-card-prefix": "交易完成時請掃描員工卡：",
  "checkout-transaction-complete-suffix": "已完成",
  "checkout-unlock-code-error-message": "員工授權碼無效。",
  "checkout-print-pool-error-message": "設定的 PrintPool 無效或無法使用。請檢查 kiosk 的 PrintPool 設定。",
  "checkout-printing-now-title": "正在列印",
  "checkout-prints-ready-message": "您的沖印品將於一分鐘內完成",
  "checkout-digitals-unlocked-message": "您的數位照片已解鎖",
  "checkout-internal-error-title": "抱歉，系統內部錯誤",
  "checkout-transaction-processed-title": "交易已完成！",
  "checkout-register-receipt-qr-message": "請掃描 QR 以登記您的電子郵件，接收電子收據與相簿連結！",
  "checkout-shop-more-btn": "繼續選購",
  "checkout-print-receipt-btn": "列印收據",
  "checkout-paid-by-cash-label": "現金付款",
  "checkout-paid-by-card-label": "刷卡付款",
  "checkout-draft-order-error-message": "建立草稿訂單失敗。",
  "checkout-print-confirmation-message": "若您有訂購沖印品，將於一分鐘內準備完成。您可於零售櫃檯領取商品",
  "checkout-shopify-params-incomplete-message": "Shopify 參數不完整",
  "checkout-event-name-required-message": "未提供 eventName。",
  "payment-no-device-connected-message": "未連接任何裝置。",
  "payment-ask-for-assistance-message": "請尋求工作人員協助。",
  "payment-square-checkout-creation-failed-message": "建立結帳請求失敗。請稍後再試。",
  "payment-square-checkout-status-check-failed-message": "檢查結帳狀態失敗。請稍後再試。",
  "payment-qr-title": "使用手機付款",
  "payment-qr-help-html": "<b>快速又方便：</b><br> 掃描上方 QR code，並按照畫面指示操作。",
  "payment-qr-transaction-progress-message": "交易進行中...",
  "payment-qr-failed-message": "QR 付款失敗。請檢查 API key 後重試。",
  "payment-failed-message": "付款失敗。請稍後再試。",
  "payment-failed-short-message": "您的付款失敗。",
  "payment-use-pinpad-message": "請使用 PinPad 完成交易...",
  "payment-terminal-progress-message": "交易處理中。<br>若要取消，請點選終端機上的箭頭。",
  "payment-transaction-canceled-message": "您的交易已取消。",
  "payment-transaction-canceled-close-btn": "返回",
  "payment-transaction-canceled-done-btn": "首頁",
  "search-version-label": "kiosk v.{{version}}",
  "search-find-by-qr-btn": "以 QR 搜尋",
  "search-find-by-face-btn": "以人臉搜尋",
  "search-scan-another-qr-placeholder": "掃描另一個 QR code",
  "search-scanned-attendee-label": "已掃描：{{attId}}",
  "search-qr-or-photos-not-found-message": "找不到 QR code 或照片。請重新掃描。",
  "scanning-qr-page-title": "相簿",
  "photo-viewer-back-btn": "返回相簿"
}
